export default {
  "1": {
    question: "شكون أحنا ؟",
    answer:
      "نحنا مجموعة من الطلبة التوانسة، إلي خايفين عليك و نحبوك ترد بالك في كل خطوة تعملها في ظل أزمة الكورونا إلي تمر بيها البلاد."
  },
  "2": {
    question: "شنيا الفايدة من الموقع هذا ؟",
    answer:
      "الموقع هذا مرتبط أساسا بخرجاتك إنت كمواطن، نحاولوا نبلغوك كان فما إصابات متواجدة في البلاصة إلي بش تمشيلها، نحاولو ننصحوك هل البلاصة إلي تحب تمشيلها مخطرة أو لا، وهكا إنت تعرف الأوقات المناسبة بش تخرج فيهم"
  },
  "3": {
    question: "كيفاش يخدم الموقع ؟ ",
    answer:
      "كي تدخل لموقعنا أول مرة، لازم تعمل حساب فيه كيما أي منصة متع تواصل إجتماعي. في كل مرة استحقيت أنك تخرج من دارك لظرف عاجل (قضية، مرض ...) تدخل لموقعنا و تعطينا البلاصة إلي تحب تمشيلها و نحنا نعطيوك معدل الخطر فيها و أنسب وقت بش تمشي و هل من المحبذ تمشي أو لا."
  },
  "4": {
    question: "شنيا الزايد في الموقع هذا ؟",
    answer:
      "في كل مرة تقدم طلب بش تمشي لبلاصة معينة، نحنا ناخذو كل البيانات المتوفرة على البلاصة أذيكا و نعطيوك نسبة مأوية تمثل احتمال أنك تلتقي بشخص حامل لفيروس الكورونا. يعني على قد ما تبدا النسبة المأوية كبيرة على قد من المستحسن أنك ما تمشيش للبلاصة أذيكا."
  },
  "5": {
    question: "فما حاجة أخرى لازم نعرفها ؟",
    answer:
      "أي، الموقع هذا مربوط بمشروع آخر إلي هو سلسلة تركب في يد المرضى أو الناس المفروض عليها الحجر الصحي. في حال فما واحد منهم خالف القانون وخرج يتم تنبيهك مباشرة إذا كانو متواجد قريب البلاصة إلي تسكن فيها أو في البلاصة إلي بش تمشيلها."
  },
  "6": {
    question: "شنيا العواقب كان مانلتزمش بتوجيهات الموقع؟",
    answer:
      "حتى شي، لأن غاية الموقع نصح المواطن وإعطائه أحسن الأوقات للخروج. أما في المقابل ممكن برشا أنك تتسبب في نشر الفيروس سواء بنقلو كان إنت مريض و مافيبالكش بروحك أو باستقبالو كان إنت لاباس عليك."
  },
  "7": {
    question: "كيفاش انجم نعاونكم؟ ",
    answer:
      "تحاول تلتزم بتوجيهات الموقع و كان الظرف العاجل خلاك تخرج رغم وجود خطر من المستحسن أنو تعلمنا في الموقع أنك مشيت للبلاصة أذيكا."
  },
  "8": {
    question: "البيانات متاعي شنيا فايدتهم؟ ",
    answer:
      "فقط بش يعاونو البرنامجج بش يعرف عدد المتواجدين في كل بلاصة بش يحسن من الخدمات متاعو بمرور الوقت"
  },
  "9": {
    question: "مشروع كيما هكا فاش بش يفيد الدولة ؟",
    answer:
      "الموقع هذا موجود بش انقصوا قدر المستطاع الإزدحام في البلاد وهكا نطيحو في سرعة انتقال الفيروس و نعاونو الدولة بش نغلبوه"
  }
};
